import ArrowBack from '../../assets/img/blue_icon-arrow-left.svg';
import { ClickableImage } from '..';

import styles from './BaseModalMobile.module.scss';

type Props = {
  children: any;
  onClose: () => void;
  isOpen: boolean;
};

const BaseModalMobile = (props: Props) => {
  const { children, onClose, isOpen } = props;

  return (
    <>
      {isOpen && (
        <div className={styles.background}>
          <div className={styles.container}>
            <div className={styles.arrowBack}>
              <ClickableImage src={ArrowBack} onClick={onClose} />
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default BaseModalMobile;
